import ShopaholicCart from '@lovata/shopaholic-cart/shopaholic-cart';
import ShopaholicCouponAdd from '@lovata/shopaholic-coupon/shopaholic-coupon-add';
import ShopaholicCouponRemove from '@lovata/shopaholic-coupon/shopaholic-coupon-remove';
import ShopaholicCartShippingType from '@lovata/shopaholic-cart/shopaholic-cart-shipping-type';
import ShopaholicOrder from '@lovata/shopaholic-cart/shopaholic-order';
import '../../../../../node_modules/jquery.maskedinput/src/jquery.maskedinput';
import CartDeliveryData from './cart-delivery-data/cart-delivery-data';

export default new class Cart {
  constructor() {
    this.obShopaholicCartShippingType = new ShopaholicCartShippingType();
    this.obShopaholicOrder = new ShopaholicOrder();
    this.obShopaholicCouponAdd = new ShopaholicCouponAdd();
    this.obShopaholicCouponRemove = new ShopaholicCouponRemove();

    this.tooltipClass = 'cart__coupon-tooltip';
    this.visibleTooltipClass = 'cart__coupon-tooltip_visible';
    this.createOrderButtonClass = '_create-order-submit';

    this.sButtonClass = 'cart__coupon-btn';
    this.buttonDisabledClass = 'button_disabled';
    this.couponWrapperClass = 'cart__coupon-input__wrapper';

    this.addButtonClass = '_shopaholic-coupon-add';
    this.removeButtonClass = '_shopaholic-coupon-remove';
    this.filledClass = 'input__field_disabled';
    this.cartPreloaderClass = 'cart__preloader';

    this.obAjaxRequestCallback = null;
    this.sComponentMethod = 'Cart::onSetShippingType';
    ShopaholicCart.instance();

    this.cartOrderingMessage = 'cart__result-message';
    this.cartOrderingMessageVisibleSelector = 'cart__result-message__hidden';

    this.isBasketPage = document.body.getAttribute('data-page-id') === 'basket';

    if (this.isBasketPage) {
      this.init();
    }
  }

  init() {
    document.addEventListener('DOMContentLoaded', () => {
      this.sendAjaxRequest();
    });

    this.initShippingType();
    this.initCreateOrder();

    this.initAddCoupon();
    this.initRemoveCoupon();
    this.initClickHandler();

    const couponField = document.querySelector(`.${this.couponWrapperClass} input`);
    const couponBtn = document.querySelector(`.${this.sButtonClass}`);

    couponField.addEventListener('keypress', (e) => {
      if (e.keyCode === 13) {
        e.preventDefault();
        couponBtn.click();
      }
    });

    couponField.addEventListener('keyup', ({ currentTarget }) => {
      const couponBtnState = currentTarget.value.length;

      couponBtn.disabled = !couponBtnState;
      if (couponBtnState) {
        couponBtn.classList.remove(this.buttonDisabledClass);
      } else {
        couponBtn.classList.add(this.buttonDisabledClass);
      }
    });
  }

  initShippingType() {
    this.obShopaholicCartShippingType.setAjaxRequestCallback((obRequestData) => {
      /* eslint-disable  no-param-reassign */
      obRequestData.update = {};
      obRequestData.update = { 'product/cart/cart-delivery/cart-delivery': '.cart-delivery__wrapper' };
      obRequestData.complete = () => {
        this.sendAjaxRequest();
        CartDeliveryData.updateDeliveryDataPartial();
      };
      /* eslint-enable */

      return obRequestData;
    });
    this.obShopaholicCartShippingType.init();
  }

  initCreateOrder() {
    $(document)
      .on('click', `.${this.createOrderButtonClass}`, () => {
        document.addEventListener('bouncerFormValid', () => {
          this.cartPreloader();
          this.obShopaholicOrder.create();
        });
      });
  }

  cartPreloader() {
    $(`.${this.cartPreloaderClass}`)
      .show();
  }

  initAddCoupon() {
    this.obShopaholicCouponAdd.setAjaxRequestCallback((obRequestData, obInput, obButton) => {
      obRequestData.complete = ({ responseJSON }) => { // eslint-disable-line no-param-reassign
        this.obShopaholicCouponAdd.completeCallback(responseJSON, obInput, obButton);
        if (responseJSON.status !== false) {
          obButton.classList.remove(this.addButtonClass);
          obButton.classList.add(this.removeButtonClass);
          obInput.classList.add(this.filledClass);
          obButton.innerHTML = 'Отменить'; // eslint-disable-line no-param-reassign
        } else {
          this.errorHandler(responseJSON.message);
          obInput.focus();
        }
      };
      return obRequestData;
    });
    this.obShopaholicCouponAdd.init();
  }

  initClickHandler() {
    $(document)
      .on('click', `.${this.sButtonClass}`, () => {
        const errorTooltip = document.querySelector(`.${this.visibleTooltipClass}`);

        if (!errorTooltip) return;

        errorTooltip.classList.remove(this.visibleTooltipClass);
      });
  }

  errorHandler(message) {
    clearTimeout(this.timer);
    const tooltip = document.querySelector(`.${this.tooltipClass}`);
    tooltip.classList.add(this.visibleTooltipClass);
    tooltip.innerHTML = message;

    this.timer = setTimeout(() => {
      tooltip.classList.remove(this.visibleTooltipClass);
    }, 2000);
  }

  initRemoveCoupon() {
    this.obShopaholicCouponRemove.setAjaxRequestCallback((obRequestData, obInput, obButton) => {
      obRequestData.complete = ({ responseJSON }) => { // eslint-disable-line no-param-reassign
        if (responseJSON.status !== false) {
          this.obShopaholicCouponRemove.completeCallback(responseJSON, obInput, obButton);
          obButton.classList.add(this.addButtonClass);
          obButton.classList.remove(this.removeButtonClass);
          obInput.classList.remove(this.filledClass);
          obInput.focus();
          obButton.innerHTML = 'Применить'; // eslint-disable-line no-param-reassign
        } else {
          this.errorHandler(responseJSON.message);
        }
      };
      return obRequestData;
    });
    this.obShopaholicCouponRemove.init();
  }

  sendAjaxRequest() {
    const shippingTypeId = this.obShopaholicCartShippingType.getShippingTypeID();

    let obRequestData = {
      data: {
        shipping_type_id: shippingTypeId,
      },
      complete: ({ responseJSON }) => {
        this.completeCallback(responseJSON);
      },
    };
    if (this.obAjaxRequestCallback !== null) {
      obRequestData = this.obAjaxRequestCallback(obRequestData);
    }
    $.request(this.sComponentMethod, obRequestData);

    let selectArea = false;

    if (!document.querySelector('input[name="order[property][shipping_address][area_code]"]')) {
      // eslint-disable-next-line no-console
      console.error('Не выбрана зона доставки');
      this.showMessage(false, 'Произошла ошибка, обновите адрес доставки');
      document.querySelector(`.${this.createOrderButtonClass}`).disabled = true;
      $(`.${this.createOrderButtonClass}`).addClass('button_disabled');
      return;
    }

    selectArea = document.querySelector('input[name="order[property][shipping_address][area_code]"]').value;

    $.request('DeliveryCheckout::onAjaxUpdate', {
      data: {
        order: {
          property: {
            shipping_type_id: shippingTypeId,
            select_area: selectArea,
            shipping_period: 0,
          },
        },
      },
      loading: `.${this.cartPreloaderClass}`,
      type: 'POST',
      complete: ({ responseJSON }) => {
        this.completeCallback(responseJSON);
        this.showMessage(responseJSON.status, responseJSON.message);

        if (!responseJSON.status) {
          document.querySelector(`.${this.createOrderButtonClass}`).disabled = true;
          $(`.${this.createOrderButtonClass}`).addClass('button_disabled');
          return;
        }
        document.querySelector(`.${this.createOrderButtonClass}`).disabled = false;
        $(`.${this.createOrderButtonClass}`).removeClass('button_disabled');
      },
    });
  }

  // eslint-disable-next-line class-methods-use-this
  completeCallback(obResponse) {
    const { data: obCartData } = obResponse;

    ShopaholicCart.instance()
      .updateCartData(obCartData);
  }

  showMessage(status, message) {
    const tooltip = document.querySelector(`.${this.cartOrderingMessage}`);
    if (!message) {
      tooltip.classList.add(this.cartOrderingMessageVisibleSelector);
    }
    tooltip.innerHTML = message;
    if (!status) {
      tooltip.classList.add('cart__result-message__error');
    } else {
      tooltip.classList.remove('cart__result-message__error');
    }
    tooltip.classList.remove(this.cartOrderingMessageVisibleSelector);
  }
}();
